module.exports = __webpack_public_path__ + "img/logo_1.4c4d6c50.png";